<script setup lang="ts">
import { KsCollapsibleTrigger } from '@aschehoug/kloss-2'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons'
</script>

<template>
  <KsCollapsibleTrigger class="collapsible-trigger">
    <slot />
    <slot name="icon">
      <FontAwesomeIcon
        class="icon"
        :icon="faChevronDown"
      />
    </slot>
  </KsCollapsibleTrigger>
</template>

<style lang="scss" scoped>
  .collapsible-trigger {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    border: none;
  }

  .collapsible-trigger svg {
    flex-shrink: 0;
    transition: transform .25s ease-in-out;
  }

  .collapsible-trigger:focus-visible {
    box-shadow: 0 0 0 3px var(--color-focus-on-light);
  }

  button[aria-expanded="true"] svg {
    transform: rotate(-180deg);
  }

  button[aria-expanded="false"] svg {
    transform: rotate(0deg);
  }
</style>
